import React from 'react';
import PropTypes from 'prop-types';
import request from '../../request';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
export default class Search extends React.Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  constructor() {
    super();
    let date = new Date();
    let month = date.getMonth() + 1;
    if (month < 10) month = `0${month}`;

    let day = date.getDate();
    if (day < 10) day = `0${day}`;

    this.state = {
      companies: [],
      start_date: `${new Date().getFullYear()}-01-01`,
      end_date: `${date.getFullYear()}-${month}-${day}`,
    };
  }

  async componentDidMount() {
    let companies = await request({
      url: 'admin/companies?all=true',
    });
    this.setState({ companies });
  }

  render() {
    let { router } = this.context;
    let { keywords, companies, company, start_date, end_date } = this.state;

    return (
      <div id="dashboard">
        <div id="head">
          <div id="title">Advanced Search</div>
          <div id="subnav" />
        </div>
        <div>
          <div className="field">
            <label htmlFor="aq">Keywords</label>
            <input
              id="aq"
              type="text"
              onChange={e => this.setState({ keywords: e.target.value })}
            />
          </div>
          <div className="field">
            <label htmlFor="co">Company</label>
            <select
              id="co"
              name="co"
              onChange={e => this.setState({ company: e.target.value })}
            >
              <option value="">Company</option>
              {companies.map(company =>
                <option key={company.id} value={company.id}>
                  {company.name}
                </option>
              )}
            </select>
          </div>
          <div className="field datepicker">
            <label htmlFor="df">From Date</label>
            <DayPickerInput
              value={start_date}
              format="YYYY-MM-DD"
              onDayChange={start_date =>
                this.setState({ start_date: start_date.format('YYYY-MM-DD') })}
            />

          </div>
          <div className="field datepicker">
            <label htmlFor="df">To Date</label>
            <DayPickerInput
              value={end_date}
              format="YYYY-MM-DD"
              onDayChange={end_date =>
                this.setState({ end_date: end_date.format('YYYY-MM-DD') })}
            />

          </div>
          <div className="options">
            <input
              id="aqb"
              type="hidden"
              name="aq"
              value="true"
              className="on"
            />
            <button
              id="go"
              type="submit"
              onClick={() =>
                router.history.push(
                  `/types?search=${keywords || ''}${company
                    ? `&company=${company}`
                    : ''}${start_date
                    ? `&start_date=${start_date}`
                    : ''}${end_date ? `&end_date=${end_date}` : ''}`
                )}
            >
              Search
            </button>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/dashboard/search.js